import { Injectable } from "@angular/core";
import { CtWebapiService, DataRequest } from "@ctsolution/ct-webapi";
import { CtWebapiGenericResponse } from "@ctsolution/ct-webapi/core/response.interface";

/**
 * Controller per la gestione del profilo utente
 */
@Injectable()
export class ProfileController {

  private controller: string = "/Profile/";

  constructor(private _webapi: CtWebapiService) {
  }

  /**
   * Recupera l'URL del dashboard SSO per la Business Intelligence
   * @returns Promise<string> - URL del dashboard BI
   */
  getSSODashboard(): Promise<string> {

    return new Promise<string>((resolve, reject) => {

      const request: DataRequest = new DataRequest(`${this.controller}GetSSODashboard`);

      this._webapi
        .get(request)
        .subscribe({
          next: (r: CtWebapiGenericResponse<string>) => resolve(r.Result),
          error: (error) => reject(error)
        });

    });

  }

}
